/* eslint-disable no-console */
/* eslint-disable radix */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../../Core/Components/Modal/CustomModal";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import Button from "../../../../Core/Components/CustomButton";
import { client } from "../../../../Utils/axiosClient";
import { updateTrips } from "../../../../Redux/Slices/trips.slice";
import StarIcon from "../../../../Common/Svgs/StarIcon";
import { updateUsers } from "../../../../Redux/Slices/users.slice";

const DriverFeedbackModal = ({ visible, onCancel }) => {
  const { driverRatingModal, currentTrip, tripsListV3 } = useSelector(
    (state) => state.trips,
  );

  const dispatch = useDispatch();

  const [comment, setComment] = useState("");
  const [rating, setRating] = useState(0);

  const onConfirm = async () => {
    try {
      await client.post(
        `${process.env.REACT_APP_API_URL}/drivers/add-feedback`,
        {
          comment,
          rating,
          driverId: driverRatingModal?.driverId || 0,
          tripId: driverRatingModal?.tripId || 0,
        },
      );
      dispatch(
        updateTrips({
          key: "driverRatingModal",
          value: { visible: false, tripId: 0, driverId: 0, driverName: "" },
        }),
      );

      dispatch(
        updateTrips({
          key: "currentTrip",
          value: {
            ...currentTrip,
            driverRating: rating,
          },
        }),
      );

      dispatch(
        updateTrips({
          key: "tripsListV3",
          value: {
            ...tripsListV3,
            result: tripsListV3.result.map((trip) =>
              trip.id === currentTrip?.id
                ? { ...trip, driverRating: rating }
                : trip,
            ),
          },
        }),
      );

      dispatch(
        updateUsers({
          key: "showToastMessage",
          value: {
            visible: true,
            data: {
              title: "Driver Rated Successfully",
            },
          },
        }),
      );

      setComment("");
      setRating(0);
    } catch (error) {
      console.error("Error submitting driver feedback:", error);
    }

    onCancel();
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="375px" centered>
      <div className="w-full p-6 rounded-md">
        <div className="flex items-center justify-between">
          <div className="font-poppins font-medium text-base">
            Driver Feedback
          </div>
          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        <div className=" mt-5">
          <p className="text-xs font-medium font-poppins">
            {driverRatingModal?.driverName}
          </p>
          <p className="mt-2 text-xs font-normal text-dark-gray font-aileron">
            Provide a rating and fedback to evaluate the driver’s performance.
          </p>
        </div>
        <div className="mt-5">
          <p className="text-xs font-normal font-aileron text-dark-gray">
            Comments (Optional)
          </p>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Add Your Comments"
            className="w-full mt-2 p-3 rounded-xl border border-purple-400 outline-none text-xs font-aileron text-dark-gray focus:ring-2 focus:ring-purple-300 focus:border-purple-500 resize-none"
            rows={3}
          />
        </div>
        <div className="flex items-center gap-2 mt-4">
          {[1, 2, 3, 4].map((num) => (
            <button
              key={num}
              onClick={() => setRating(num)}
              type="button"
              className="focus:outline-none"
            >
              <StarIcon
                size={18}
                fill={num <= rating ? "#FFD700" : "none"}
                stroke="#525252"
                strokeWidth={1.5}
              />
            </button>
          ))}
        </div>

        <div className="gap-x-3 mt-5.5">
          <Button colors="mobilizePrimary" size="primary" onClick={onConfirm}>
            Save
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default DriverFeedbackModal;
